import { shopPrefix } from '../../../config';
import { http } from '../../../api/axios';
import { SelectionListCommentOut } from '../../../store/api';

interface Params {
    listId: string;
    text: string;
}

const url = `${shopPrefix}/v2/selectionlists/:listId/comments`;
export const createComment = ({ listId, text }: Params) => {
    return http
        .post<SelectionListCommentOut>(
            url,
            { text },
            {
                pathParams: { listId }
            }
        )
        .then(res => {
            return res.data;
        });
};
